export const isEmbeddedImage = (url: string) => {
  const regex = /\.(jpeg|jpg|jfif|pjepg|pjp|gif|png|apng|bmp|ico|cur|svg|webp)$/i;
  return regex.test(url);
};

export const isEmbeddedVideo = (url: string) => {
  const regex = /\.(mp4|mov|m4v|webm|mkv)$/i;
  return regex.test(url);
};

export const isEmbeddedAudio = (url: string) => {
  const regex = /\.(mp3|wav)$/i;
  return regex.test(url);
};
